import {forwardRef, useState} from 'react';
import { Box, Grid, IconButton, Popover, Typography } from '@mui/material';
import ColorConstants from '../../../defaults/ColorConstants';
import HelpIcon from "@mui/icons-material/Help";

export const MapLegend = forwardRef(() => {
  const [legendPopoverIsOpen, setLegendPopoverIsOpen] = useState(false);
  const [legendAnchorEl, setLegendAnchorEl] = useState(null);

  const openLegendPopover = (event) => {
    setLegendAnchorEl(event.currentTarget);
    setLegendPopoverIsOpen(true);
  }

  const closeLegendPopover = () => {
    setLegendPopoverIsOpen(false);
    setLegendAnchorEl(null);
  }

  return (
    <div className='blue-msg-bottom' style={{marginRight: "5px"}}>
      <Typography style={{ paddingTop: "1px" }} fontSize={12}>
        Legend: 
      </Typography>
      <IconButton style={{ padding: 0 }} aria-label="Help"
            onClick={(event) => openLegendPopover(event)}>
          <HelpIcon fontSize="small" color="primary" style={{ right: "0px" }} />
      </IconButton>    
      <Popover
        id={'legend-popover'}
        open={legendPopoverIsOpen}
        style={{ minWidth: '300px', maxWidth: '800px', maxHeight: '75vh' }}
        anchorEl={legendAnchorEl}
        onClose={closeLegendPopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <div style={{maxHeight: '375px', overflowY: 'scroll', width: '310px'}}>
          <Box sx={{textAlign: 'center'}}>
            <Typography fontWeight={'bold'} sx={{textDecoration: 'underline'}}>Status Colors</Typography>
          </Box>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.NotStarted}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Not Started</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.Started}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Started</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.Draft}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Draft</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.ReadyForApproval}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Ready For Approval</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.LocalApproved}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Approved (Local)</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.RegionApproved}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Approved (Regional)</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.AgencyApproved}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Approved (Agency)</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.DepartmentApproved}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Approved (Department)</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.StatusColors.Completed}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Completed</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} className={`cancelled-color`}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Canceled</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} className={`un-approval-requested-color`}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>UnApproval Requested</Typography>
            </Grid>
          </Grid>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.ProjectColors.Default}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Project</Typography>
            </Grid>
          </Grid>
          <Box sx={{textAlign: 'center'}}>
            <Typography fontWeight={'bold'} sx={{textDecoration: 'underline'}}>Card Colors</Typography>
          </Box>
          <Grid container sx={{marginBottom: 1}}>
            <Grid item size={1} sx={{border:2, marginLeft:1}} bgcolor={ColorConstants.CarryOver}/>
            <Grid item size={1}/>
            <Grid item size={7}>
              <Typography>Carryover</Typography>
            </Grid>
          </Grid>
        </div>
      </Popover>
    </div>
  );
});
